import { GetNovelsRequest, type NovelItem } from '@app/_proto/Protos/novels';
import { NovelsClient } from '@app/_proto/Protos/novels.client';
import { VipItem_VipType } from '@app/_proto/Protos/vips';
import { useGrpcApiWithQuery } from '@app/libs/api';
import type { User } from '@app/libs/auth';
import { useGrpcRequest } from '@app/libs/grpc';
import { useMemo } from 'react';

type UseVipFreeNovelsParam = {
    user: User | undefined;
};
type UseVipFreeNovelsReturn = {
    data: NovelItem[] | undefined;
    isLoading: boolean;
};

export default function useVipFreeNovels({ user }: UseVipFreeNovelsParam): UseVipFreeNovelsReturn {
    const novelsRequest = useGrpcRequest(GetNovelsRequest, {
        filters: [
            {
                filter: {
                    oneofKind: 'isLocked',
                    isLocked: true,
                },
            },
        ],
        pageInfo: {
            page: 1,
            count: 100,
        },
    });
    const { data: completedNovels, isLoading } = useGrpcApiWithQuery(
        NovelsClient,
        c => c.getNovels,
        novelsRequest,
        ['novels', 'locked'],
        {
            enabled:
                (user?.isVipActive && [VipItem_VipType.Silver, VipItem_VipType.Gold].includes(user?.vip?.type ?? -1)) ??
                false,
        }
    );

    const vipFreeNovels = useMemo(() => {
        return (completedNovels?.items ?? []).filter(completedNovel => !completedNovel.karmaInfo?.isFree);
    }, [completedNovels]);
    return {
        data: vipFreeNovels,
        isLoading,
    };
}
